import React, { Fragment, ReactNode, useEffect } from "react";
import { connect } from "react-redux";
import { ApplicationStore } from "src/store";
import Frame from "react-frame-component";
import "./frame.scss";
import { useMobileMediaQuery } from "Shared/Responsive";

interface Props {
    children: ReactNode;
}

const FrameProvider = ({
    children,
    isFlyoutGarageOpen,
    garageVehiclesCount,
    isAppOpen,
    mobile_flyout_placement,
    flyout_placement,
}: Props & ReturnType<typeof mapStateToProps>) => {
    useEffect(() => {
        document.body.classList.toggle("os-open", isAppOpen);
    }, [isAppOpen]);

    const isMobile = useMobileMediaQuery();

    const classList = ["os-iframe-container"];

    if (isAppOpen || (isMobile ? mobile_flyout_placement !== "disabled" : flyout_placement !== "disabled")) {
        classList.push("os-iframe-container--visible");
    }

    if (!isAppOpen) {
        classList.push(
            isFlyoutGarageOpen ? "os-iframe-container--open" : "os-iframe-container--close",
            `os-iframe-container--${isMobile ? mobile_flyout_placement : flyout_placement}`,
            "os-iframe-container",
            garageVehiclesCount > 0
                ? garageVehiclesCount > 1
                    ? "os-iframe-container--garage-multiple"
                    : "os-iframe-container--garage-simple"
                : "os-iframe-container--garage-empty"
        );
    }

    return (
        <Fragment>
            <Frame
                id={"os-iframe-container"}
                className={classList.join(" ")}
                initialContent={`
                    <!DOCTYPE html>
                    <html lang="${document.documentElement.lang}">
                    <head>
                      <meta charset="utf-8" />
                      <meta content="width=device-width, initial-scale=1, shrink-to-fit=no, maximum-scale=1, user-scalable=no"
                            name="viewport" />
                      <meta content="#000000" name="theme-color" />
                      <link id="jss-insertion-point" />
                      <link href="${process.env.PUBLIC_URL}/app.css" rel="stylesheet">
                      <script async src="https://www.googletagmanager.com/gtag/js?id=G-ZQMCC9TNWY&l=osAnalyticsDataLayer"></script>
                      <script>
                        window.osAnalyticsDataLayer = window.osAnalyticsDataLayer || [];
                        function osAnalytics() {
                          osAnalyticsDataLayer.push(arguments);
                        }
                        osAnalytics("js", new Date());
                      </script>
                      <title>DealerInspire - Online Shopper Electric</title>
                    </head>
                    <body>
                    <div id="root"></div>
                    </body>
                    </html>
                `}
                mountTarget={"#root"}
            >
                {children}
            </Frame>
            <div className={`os-iframe-backdrop ${isFlyoutGarageOpen ? "os-iframe-backdrop--visible" : ""}`} />
        </Fragment>
    );
};

const mapStateToProps = (state: ApplicationStore) => ({
    mobile_flyout_placement:
        state.account.settings?.electric?.mobile_flyout_placement ?? ("right-middle" as "right-middle"),
    flyout_placement: state.account.settings?.electric?.flyout_placement ?? ("right-middle" as "right-middle"),
    isFlyoutGarageOpen: state.onlineShopper.isFlyoutOpen,
    garageVehiclesCount: state.vehicles.order.length,
    isAppOpen: state.onlineShopper.isAppOpen,
});

export default connect(mapStateToProps)(FrameProvider);
